import React, {useEffect, useState} from 'react';

import styles from './CatalogPage.module.css'
import {Filters} from "../../ui/Filters/Filters.tsx";
import {SearchProductList} from "./components/SearchProductList/SearchProductList.tsx";
import {Product} from "../../widgets/ProductCard/types/productCard.interface.ts";
import {FilterSchema, FilterType} from "../../ui/Filters/types/filterSchema.interface.tsx";
import {Button} from "../../ui/General/Button/Button.tsx";
import {LimitPages} from "../../widgets/LimitPages/LimitPages.tsx";
import { LinearLoader } from '../../ui/LinearLoader/LinearLoader.tsx';
import { API_URL } from '../../config.tsx';

interface Props {
}

export const CatalogPage: React.FC<Props> = () => {
    const step = 5;
    const url = new URL(window?.location.href || '');
    const queryParam = url.searchParams.get('name');
    const idParam = url.searchParams.get('id');
    const [products, setProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [filterSchema, setFilterSchema] = useState<FilterSchema[]>([]);
    const [filteredBrandsIds, setFilteredBrandsIds] = useState<number[]>([]);
    const [maxPage, setMaxPage] = useState(1);
    const [page, setPage] = useState(1);

    // window.onscroll = function () {
    //     if(document.documentElement.scrollTop > document.body.clientHeight - window.innerHeight - 200) {
    //         setProductsLength(productsLength + 3);
    //     }
    // }


    const findProducts = (page: number) => {
        setLoading(true);
        if(!queryParam) {
            setLoading(false);
            return;
        }
        fetch(`${API_URL}/find_catalog_parts?query=${queryParam}&categoryId=${idParam}&offset=0&limit=${step * page}&brands=${filteredBrandsIds.join(',')}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => {
                if(Object.keys(result).length === 0) {
                    return;
                }
                let filterSchema: FilterSchema[] = [
                    {
                        type: FilterType.checkbox,
                        label: 'Бренд',
                        name: 'brand',
                        values: result.brands
                    }
                ]

                filterSchema[0].values.sort(function(a, b){
                    return a.count && b.count && b.count < a.count ? -1 : 1;
                });
                setProducts(result.products);
                setFilterSchema(filterSchema);
                setMaxPage(Math.ceil(result.count / step));
            }).then(() => setLoading(false))
    };

    const changeFilteredBrandsIds = (ids: number[]) => {
        setFilteredBrandsIds(ids);
    }

    const openNextPage = (page: number) => {
        setPage(page);
        findProducts(page);
    }

    const onFiltersApply = () => {
        setProducts([]);
        setPage(1);
        setMaxPage(1);
        findProducts(1);
    }

    const clearFilter = () => {
        setProducts([]);
        setPage(1);
        setMaxPage(1);
        findProducts(1);
    }

    useEffect(() => {
        findProducts(page);
    }, []);


    return (
            <div className={styles.wrapper}>
                <Filters
                    schema={filterSchema}
                    setIds={changeFilteredBrandsIds}
                    onFiltersApply={onFiltersApply}
                    clearFilter={clearFilter}
                    showButton={true}
                />
                <div>
                    <SearchProductList
                        products={products}
                        productsLength={page * step}
                    />
                    {
                        loading &&
                        (<div style={{textAlign: 'center', marginTop: 24, marginBottom: 24,}}>
                            <div className={styles.loader} style={{width: '100%',display: 'block'}}><LinearLoader/></div>
                        </div>)
                    }
                    {
                        page < maxPage
                        ? <div>
                            <Button onClick={() => openNextPage(page + 1)} className={styles.showMoreBtn}>
                                Показать ещё
                            </Button>
                        </div>
                        : null
                    }
                    {
                        products.length
                            ? <div style={{textAlign: 'center', marginTop: 24,}}>
                                <LimitPages maxPage={maxPage} openNextPage={openNextPage} page={page}/>
                            </div>
                            : null
                    }
                </div>
            </div>
    );
};
